import { render, staticRenderFns } from "./RoutineEditor.vue?vue&type=template&id=0c173890&scoped=true"
import script from "./RoutineEditor.vue?vue&type=script&lang=js"
export * from "./RoutineEditor.vue?vue&type=script&lang=js"
import style0 from "./RoutineEditor.vue?vue&type=style&index=0&id=0c173890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c173890",
  null
  
)

export default component.exports